export const chargePointActionTypes = {
  START_GET_CHARGE_POINT: "START_GET_CHARGE_POINT",
  GET_CHARGE_POINT_SUCCESS: "GET_CHARGE_POINT_SUCCESS",
  GET_CHARGE_POINT_FAILURE: "GET_CHARGE_POINT_FAILURE",

  START_CHARGING_TRANSACTION_REQUEST: "START_CHARGING_TRANSACTION_REQUEST",
  START_CHARGING_TRANSACTION_SUCCESS: "START_CHARGING_TRANSACTION_SUCCESS",
  START_CHARGING_TRANSACTION_FAILURE: "START_CHARGING_TRANSACTION_FAILURE",

  STOP_CHARGING_TRANSACTION_REQUEST: "STOP_CHARGING_TRANSACTION_REQUEST",
  STOP_CHARGING_TRANSACTION_SUCCESS: "STOP_CHARGING_TRANSACTION_SUCCESS",
  STOP_CHARGING_TRANSACTION_FAILURE: "STOP_CHARGING_TRANSACTION_FAILURE",

  START_GET_OPEN_CHARGING_TRANSACTION: "START_GET_OPEN_CHARGING_TRANSACTION",
  GET_OPEN_CHARGING_TRANSACTION_SUCCESS: "GET_OPEN_CHARGING_TRANSACTION_SUCCESS",
  GET_OPEN_CHARGING_TRANSACTION_FAILURE: "GET_OPEN_CHARGING_TRANSACTION_FAILURE",

  START_GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN: "START_GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN",
  GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_SUCCESS: "GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_SUCCESS",
  GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_FAILURE: "GET_CHARGING_TRANSACTION_DETAILS_BY_TOKEN_FAILURE",

  RESET_SELECTED_CHARGE_POINT: "RESET_SELECTED_CHARGE_POINT",
};
